// Whoever's looking at this code, I manually had to input this info cuz I had no idea how to automate this

export const Courses =[
    { course: "AFM", faculty: "ART", name: "Accounting & Financial Management"},
    { course: "ASL", faculty: "ART", name: "American Sign Language"},
    { course: "ANTH", faculty: "ART", name:"Anthropology"},
    { course: "APPLS", faculty:"ART", name:"Applied Language Studies"},
    { course: "ARABIC", faculty:"ART", name:"Arabic"},
    { course: "ARTS", faculty:"ART", name:"Arts"},
    { course: "ARBUS", faculty:"ART", name:"Arts and Business"},
    { course: "BLKST", faculty:"ART", name:"Black Studies"},
    { course: "CDNST", faculty:"ART", name:"Canadian Studies"},
    { course: "CHINA", faculty:"ART", name:"Chinese"},
    { course: "CMW", faculty:"ART", name:"Church Music and Worship"},
    { course: "CLAS", faculty:"ART", name:"Classical Studies"},
    { course: "COGSCI", faculty:"ART", name:"Cognitive Science"},
    { course: "CROAT", faculty:"ART", name:"Croatian"},
    { course: "CI", faculty:"ART", name:"Cultural Identities"},
    { course: "DAC", faculty:"ART", name:"Digital Arts Communication"},
    { course: "DUTCH", faculty:"ART", name:"Dutch"},
    { course: "EASIA", faculty:"ART", name:"East Asian Studies"},
    { course: "ECON", faculty:"ART", name:"Economics"},
    { course: "ENGL", faculty:"ART", name:"English"},
    { course: "FINE", faculty:"ART", name:"Fine Arts"},
    { course: "FR", faculty:"ART", name:"French Studies/Études Françaises"},
    { course: "GSJ", faculty:"ART", name:"Gender and Social Justice"},
    { course: "GER", faculty:"ART", name:"German"},
    { course: "GBDA", faculty:"ART", name:"Global Business and Digital Arts"},
    { course: "GRK", faculty:"ART", name:"Greek"},
    { course: "HIST", faculty:"ART", name:"History"},
    { course: "HRM", faculty:"ART", name:"Human Resources Management"},
    { course: "HRTS", faculty:"ART", name:"Human Rights"},
    { course: "HUMSC", faculty:"ART", name:"Human Sciences"},
    { course: "INDENT", faculty:"ART", name:"Indigenous Entrepreneurship"},
    { course: "INDG", faculty:"ART", name:"Indigenous Studies"},
    { course: "INTST", faculty:"ART", name:"International Studies"},
    { course: "ITAL", faculty:"ART", name:"Italian"},
    { course: "ITALST", faculty:"ART", name:"Italian Studies"},
    { course: "JAPAN", faculty:"ART", name:"Japanese"},
    { course: "JS", faculty:"ART", name:"Jewish Studies"},
    { course: "KOREA", faculty:"ART", name:"Korean"},
    { course: "LAT", faculty:"ART", name:"Latin"},
    { course: "LS", faculty:"ART", name:"Legal Studies"},
    { course: "MGMT", faculty:"ART", name:"Management"},
    { course: "MEDVL", faculty:"ART", name:"Medieval Studies"},
    { course: "MENN", faculty:"ART", name:"Mennonite Studies"},
    { course: "MOHAWK", faculty:"ART", name:"Mohawk"},
    { course: "MUSIC", faculty:"ART", name:"Music"},
    { course: "PACS", faculty:"ART", name:"Peace and Conflict Studies"},
    { course: "PHIL", faculty:"ART", name:"Philosophy"},
    { course: "PSCI", faculty:"ART", name:"Political Science"},
    { course: "PORT", faculty:"ART", name:"Portuguese"},
    { course: "PSYCH", faculty:"ART", name:"Psychology"},
    { course: "RS", faculty:"ART", name:"Religious Studies"},
    { course: "RUSS", faculty:"ART", name:"Russian"},
    { course: "REES", faculty:"ART", name:"Russian and East European Studies"},
    { course: "SMF", faculty:"ART", name:"Sexuality, Marriage, and Family Studies"},
    { course: "SDS", faculty:"ART", name:"Social Development Studies"},
    { course: "SOCWK", faculty:"ART", name:"Social Work (Social Development Studies)"},
    { course: "SOC", faculty:"ART", name:"Sociology"},
    { course: "SPAN", faculty:"ART", name:"Spanish"},
    { course: "SPCOM", faculty:"ART", name:"Speech Communication"},
    { course: "SI", faculty:"ART", name:"Studies in Islam"},
    { course: "THPERF", faculty:"ART", name:"Theatre and Performance"},
    { course: "VCULT", faculty:"ART", name:"Visual Culture"},
    { course: "AE", faculty:"ENG", name:"Architectural Engineering"},
    { course: "ARCH", faculty:"ENG", name:"Architecture"},
    { course: "BME", faculty:"ENG", name:"Biomedical Engineering"},
    { course: "BET", faculty:"ENG", name:"Business, Entrepreneurship and Technology"},
    { course: "CHE", faculty:"ENG", name:"Chemical Engineering"},
    { course: "CIVE", faculty:"ENG", name:"Civil Engineering"},
    { course: "ECE", faculty:"ENG", name:"Electrical and Computer Engineering"},
    { course: "ENVE", faculty:"ENG", name:"Environmental Engineering"},
    { course: "GENE", faculty:"ENG", name:"General Engineering"},
    { course: "GEOE", faculty:"ENG", name:"Geological Engineering"},
    { course: "MSCI", faculty:"ENG", name:"Management Sciences"},
    { course: "ME", faculty:"ENG", name:"Mechanical Engineering"},
    { course: "MTE", faculty:"ENG", name:"Mechatronics Engineering"},
    { course: "NE", faculty:"ENG", name:"Nanotechnology Engineering"},
    { course: "PDARCH", faculty:"ENG", name:"Professional Development for Architecture Students"},
    { course: "SYDE", faculty:"ENG", name:"Systems Design Engineering"},
    { course: "ENVS", faculty:"ENV", name:"Environment"},
    { course: "ENBUS", faculty:"ENV", name:"Environment and Business"},
    { course: "ERS", faculty:"ENV", name:"Environment, Resources and Sustainability"},
    { course: "GEOG", faculty:"ENV", name:"Geography and Environmental Management"},
    { course: "INDEV", faculty:"ENV", name:"International Development"},
    { course: "INTEG", faculty:"ENV", name:"Knowledge Integration"},
    { course: "PLAN", faculty:"ENV", name:"Planning"},
    { course: "GERON", faculty:"HEA", name:"Gerontology"},
    { course: "HEALTH", faculty:"HEA", name:"Health"},
    { course: "KIN", faculty:"HEA", name:"Kinesiology"},
    { course: "HLTH", faculty:"HEA", name:"Public Health Sciences"},
    { course: "REC", faculty:"HEA", name:"Recreation and Leisure Studies"},
    { course: "ACTSC", faculty:"MAT", name:"Actuarial Science"},
    { course: "AMATH", faculty:"MAT", name:"Applied Mathematics"},
    { course: "CO", faculty:"MAT", name:"Combinatorics and Optimization"},
    { course: "COMM", faculty:"MAT", name:"Commerce"},
    { course: "CS", faculty:"MAT", name:"Computer Science"},
    { course: "MATBUS", faculty:"MAT", name:"Mathematical Business"},
    { course: "MATH", faculty:"MAT", name:"Mathematics"},
    { course: "MTHEL", faculty:"MAT", name:"Mathematics Electives"},
    { course: "PMATH", faculty:"MAT", name:"Pure Mathematics"},
    { course: "STAT", faculty:"MAT", name:"Statistics"},
    { course: "BASE", faculty:"REN", name:"Bridge to Academic Success in English"},
    { course: "EMLS", faculty:"REN", name:"English for Multilingual Speakers"},
    { course: "SWREN", faculty:"REN", name:"Social Work (Bachelor of Social Work)"},
    { course: "BIOL", faculty:"SCI", name:"Biology"},
    { course: "CHEM", faculty:"SCI", name:"Chemistry"},
    { course: "EARTH", faculty:"SCI", name:"Earth Sciences"},
    { course: "MNS", faculty:"SCI", name:"Materials and Nano-Sciences"},
    { course: "OPTOM", faculty:"SCI", name:"Optometry"},
    { course: "PHARM", faculty:"SCI", name:"Pharmacy"},
    { course: "PHYS", faculty:"SCI", name:"Physics"},
    { course: "SCI", faculty:"SCI", name:"Science"},
    { course: "SCBUS", faculty:"SCI", name:"Science and Business"},
    { course: "PDPHRM", faculty:"SCI", name:"Professional Development for Pharmacy Students"},
    { course: "AVIA", faculty:"VPA", name:"Aviation"},
    { course: "CFM", faculty:"VPA", name:"Computing and Financial Management"},
    { course: "COOP", faculty:"VPA", name:"Co-operative Work Term"},
    { course: "PD", faculty:"VPA", name:"Professional Development"},
    { course: "STV", faculty:"VPA", name:"Society, Technology and Values"},
    { course: "SE", faculty:"VPA", name:"Software Engineering"},
    { course: "SFM", faculty:"VPA", name:"Sustainability and Financial Management"},
    { course: "UNIV", faculty:"VPA", name:"University"},
    { course: "WKRPT", faculty:"VPA", name:"Work-term Report"},
    { course: "BUS", faculty: "WLU", name:"Business (Wilfrid Laurier University)"},
];